document.addEventListener('DOMContentLoaded', function() {
    const second = 1000;
    const minute = second * 60;
    const hour = minute * 60;
    const day = hour * 24;

    // Get the deadline date string from the HTML element
    let deadline = document.querySelector("#deadline");

    // If the deadline element doesn't exist, exit the function
    if (!deadline) {
        return;
    }

    const deadlineDate = deadline.dataset.date;

    // Split the date string into day, month, and year parts
    const [dayy, month, year] = deadlineDate.split('/');

    // Create a new Date object
    const dateObject = new Date(`${year}-${month}-${dayy}`);

    // Get the timestamp (in milliseconds) for the deadline
    const deadlineTimestamp = dateObject.getTime();

    // Triggers when deadline is empty
    if (!deadlineTimestamp || deadlineTimestamp == null || deadlineTimestamp == NaN) {
        deadline.style.display = 'none'; // Hide the deadline block
        setTimeout(() => {
            showPopup();
        }, 1750); // 1.75 seconds
    }

    // Triggers when countdown is completed
    if ((deadlineTimestamp - Date.now()) < 0) {
        return;
    }

    // Set up an interval to update the countdown timer
    const countdownInterval = setInterval(function () {
        let timeDifference = deadlineTimestamp - Date.now();

        // Calculate and update the countdown elements
        document.getElementById("days").innerHTML = Math.floor(timeDifference / day) < 1 ? null : `<span>${Math.floor(timeDifference / day)}</span><p>jours</p>`;
        document.getElementById("hours").innerHTML = Math.floor((timeDifference % day) / hour) < 1 ? null : `<span>${Math.floor((timeDifference % day) / hour)}</span><p>heures</p>`;
        document.getElementById("minutes").innerHTML = Math.floor((timeDifference % hour) / minute) < 1 ? null : `<span>${Math.floor((timeDifference % hour) / minute)}</span><p>minutes</p>`;
        document.getElementById("seconds").innerHTML = Math.floor((timeDifference % minute) / second) < 0 ? null : `<span>${Math.floor((timeDifference % minute) / second)}</span><p>secondes</p>`;

    }, 1000); // Set the interval to 1000 milliseconds (1 second)

    // Check if the popup has already been shown
    let isFirstLoad = true;
    let showPopupKey = sessionStorage.getItem("showPopupKey");

    // Function to show the popup
    function showPopup() {
        if (showPopupKey == "false") {
            return;
        }
        const popup = document.getElementById("popup-cta");
        setTimeout(() => {
            popup.classList.add("active");
            // Set the sessionStorage variable to mark the popup as shown
            sessionStorage.setItem("showPopupKey", false);
            isFirstLoad = false;
        }, 10);
    }

    // If the popup hasn't been shown before, wait 1.75 seconds and then show it
    if (isFirstLoad) {
        setTimeout(() => {
            showPopup();
        }, 1750); // 1.75 seconds
    }
});
